import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import {
    submitDefaultAddressSuccess,
    submitDefaultAddressError,
} from '@perpay-web/fintech/actions/entities/defaultAddress';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import { resetAddressDetails } from '@perpay-web/fintech/actions/ui/addressDetails';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { handleError } from '@perpay-web/observable/operators/handleError';

export const submitDefaultAddress = (action$) =>
    action$.pipe(
        ofType(submitDefaultAddressSuccess().type),
        mergeMap(() => [
            resetAddressDetails(),
            routeToLocation(paths.profile.path),
        ]),
        handleError((error) => [submitDefaultAddressError(error)]),
    );
